import { getId } from '@store/utils'

import type { Options } from './types'

const state: Options = [
  {
    id: getId(),
    label: 'I need features that are missing',
    checked: false,
    input: {
      name: 'features',
      placeholder: 'What features do you need?',
      value: '',
    },
  },
  {
    id: getId(),
    label: 'I found a better product',
    checked: false,
    options: [
      {
        id: getId(),
        label: 'Miro',
        checked: false,
      },
      {
        id: getId(),
        label: 'Whimsical',
        checked: false,
      },
      {
        id: getId(),
        label: 'Flowmapp',
        checked: false,
      },
      {
        id: getId(),
        label: 'Other',
        checked: false,
        input: {
          name: 'product',
          placeholder: 'What product did you found?',
          value: '',
        },
      },
    ],
  },
  {
    id: getId(),
    label: `It's not what I expected`,
    checked: false,
    options: [
      {
        id: getId(),
        label: 'Buggy interface',
        checked: false,
      },
      {
        id: getId(),
        label: 'Features not working',
        checked: false,
      },
    ],
  },
  {
    id: getId(),
    label: 'I use the service too rarely',
    checked: false,
  },
  {
    id: getId(),
    label: `I don't like subscriptions`,
    checked: false,
  },
  {
    id: getId(),
    label: `Other`,
    checked: false,
    input: {
      name: 'other',
      placeholder: 'Other reason',
      value: '',
    },
  },
]

export default state
